import { useContext } from 'react';
import { ApplicationPaths } from '../Services/Auth/AuthConstants';
import { Dropdown, NavDropdown} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AuthContext } from './Auth/AuthProvider';
import { ProfileContext } from "./Auth/ProfileProvider";

export const NavItems = ({ }: { children: any }) => {

    const authContext = useContext(AuthContext);
    const { user } = useContext(ProfileContext);


    const authenticatedView = () => {
        const logoutPath = { pathname: `${ApplicationPaths.LogOut}`, state: { local: true } };
        return (
            <Dropdown className="nav-item">
                <Dropdown.Toggle className="nav-link pp-nav-dropdown-toggle pp-nav-btn" variant="pp-secondary">
                    <span className="pp-nav-dropdown-icon"><i className="las la-bars"></i></span>
                    <span className="pp-nav-dropdown-text">MENU</span>
                </Dropdown.Toggle>
                    {user?.isOtherBoardPhysician ?
                        <Dropdown.Menu className="dropdown-menu-right text-nowrap">
                            <Dropdown.Item className="pp-nav-link font-weight-bold" as={Link} to={'/Messages'}>Messages</Dropdown.Item>
                            <NavDropdown.Divider className="m-0" />
                            <Dropdown.Item className="pp-nav-link font-weight-bold" as={Link} to={logoutPath}>Logout</Dropdown.Item>
                        </Dropdown.Menu>
                        :
                        <Dropdown.Menu className="dropdown-menu-right text-nowrap">
                            <Dropdown.Item className="pp-nav-link font-weight-bold" as={Link} to={'/'}>Home</Dropdown.Item>
                            <NavDropdown.Divider className="m-0" />
                            <Dropdown.Item className="pp-nav-link font-weight-bold" as={Link} to={'/ExaminationHistory'}>Exam History</Dropdown.Item>
                            <NavDropdown.Divider className="m-0" />
                            <Dropdown.Item className="pp-nav-link font-weight-bold" as={Link} to={'/PaymentsAndReceipts'}>Payments and Receipts</Dropdown.Item>
                            <NavDropdown.Divider className="m-0" />
                            <Dropdown.Item className="pp-nav-link font-weight-bold" as={Link} to={'/ManageActivities'}>Activity Records</Dropdown.Item>
                            <NavDropdown.Divider className="m-0" />
                            <Dropdown.Item className="pp-nav-link font-weight-bold" as={Link} to={'/Messages'}>Messages</Dropdown.Item>
                            <NavDropdown.Divider className="m-0" />
                            <Dropdown.Item className="pp-nav-link font-weight-bold" as={Link} to={'/AccountInformation'}>Account Information</Dropdown.Item>
                            <NavDropdown.Divider className="m-0" />
                            <Dropdown.Item className="pp-nav-link font-weight-bold" as={Link} to={logoutPath}>Logout</Dropdown.Item>
                        </Dropdown.Menu>
                    }
            </Dropdown>
        )
    };

    const anonymousView = () => {
        return (<div className="d-sm-inline-flex flex-sm-row-reverse" >
            <Dropdown.Item className="text-light" as={Link} to={ApplicationPaths.Login}>Login</Dropdown.Item>
        </div>);
    };

    if (!authContext.isAuthenticated()) {
        return anonymousView();
    } else {
        return authenticatedView();
    }
}